class TextController {
  constructor($sce) {
    this.$sce = $sce;
  }

  get content() {
    return this.article && this.article.__content ?
      this.$sce.trustAsHtml(this.article.__content) : '';
  }
}

export default TextController;



// WEBPACK FOOTER //
// ./client/app/components/content-types/text/text.controller.js